import React from 'react';

const Spinner = () => <div>loading...</div>;

export default Spinner;
